import React, { CSSProperties, PureComponent } from 'react';
import { DatedRatePeriod, StopSellPeriod } from '../../api/pricing/pricing.types';

interface RateSquareProps {
  id: string;
  isEmpty?: boolean;
  stopSells: StopSellPeriod[];
  date: string;
  largestPerDay: number;
  smallestPerDay: number;
  rateInfo?: DatedRatePeriod;
  onRateSquareClick: (info: RateSquareInfo) => void;
}

interface SquareColor {
  r: number;
  g: number;
  b: number;
}

export interface RateSquareInfo {
  id: string;
  stopSells: StopSellPeriod[];
  date: string;
  rateDetails: DatedRatePeriod;
  ref: any;
}

export class RateSquare extends PureComponent<RateSquareProps> {

  ref = React.createRef<HTMLDivElement>();

  // eslint-disable-next-line consistent-return
  calculateColor = () => {
    if (this.props.stopSells.length) return { backgroundColor: 'rgb(153,153,153)' } as CSSProperties;
    if (this.props.smallestPerDay === this.props.largestPerDay) return { backgroundColor: 'rgb(167,246,153)' };

    if (this.props.rateInfo && !this.props.isEmpty) {
      const color1: SquareColor = { r: 255, g: 102, b: 102 };
      const color2: SquareColor = { r: 167, g: 246, b: 153 };
      const weight = ((this.props.rateInfo.totalPerDay - this.props.smallestPerDay) / ((this.props.largestPerDay - this.props.smallestPerDay) / 100)) / 100;
      const weight2 = 1 - weight;

      const rgb: SquareColor = {
        r: Math.round(color1.r * weight + color2.r * weight2),
        g: Math.round(color1.g * weight + color2.g * weight2),
        b: Math.round(color1.b * weight + color2.b * weight2)
      };

      return { backgroundColor: `rgb(${rgb.r},${rgb.g},${rgb.b})` } as CSSProperties;
    }
  };

  getClass = () => {
    if (this.props.isEmpty) return 'rate-square empty-square';

    return 'rate-square';
  };

  onPress = () => {
    if (this.props.rateInfo && !this.props.isEmpty) {
      const info: RateSquareInfo = {
        id: this.props.id,
        stopSells: this.props.stopSells,
        date: this.props.date,
        rateDetails: this.props.rateInfo,
        ref: this.ref
      };

      this.props.onRateSquareClick(info);
    }
  };

  render() {
    return (
      <div
        ref={this.ref}
        id={this.props.id}
        style={!this.props.isEmpty ? this.calculateColor() : undefined}
        onClick={this.onPress}
        className={this.getClass()}
        tabIndex={0}
        role="button"
      >
        {this.props.rateInfo && this.props.rateInfo.isAdjustment && this.props.stopSells.length === 0 && (
          <div className="rate-adjustment-square" />
        )}
      </div>
    );
  }
}
